/* eslint-disable */
import Vue from 'vue';
import router from '../../routes';

const todo = {
    namespaced: true,
    state:{
        token:'',
        todo:[],
        updated: false,
        weekItemSaved: false,
        customItemError: []
    },
    getters:{
        getTodo(state) {
            return state.todo;
        },
        getItems: (state) => (groupID) => {
            var filteredList = [];
            var i;
            for(i=0;i<state.todo.items.length;i++) {
                if(state.todo.items[i].todogroupID == groupID && (state.todo.items[i].done === null || state.todo.items[i].done == false)) {
                    filteredList.push(state.todo.items[i])
                }
            }

            return filteredList;
        },
        getCompletedItems: (state) => (groupID) => {
            var filteredList = [];
            var i;
            for(i=0;i<state.todo.items.length;i++) {
                if(state.todo.items[i].todogroupID == groupID && state.todo.items[i].done == 1) {
                    filteredList.push(state.todo.items[i])
                }
            }

            return filteredList;
        },
        getStateUpdated(state) {
            return state.updated;
        },
        getCustomItemResponse(state) {
            return state.customItemError;
        }
    },
    mutations: {
        getTodo(state,todoData) {
            state.todo = todoData;
        },
        customItemAdded(state, customItem) {
            state.updated = customItem;
        },
        customItemResponse(state, error) {
            state.customItemError = error;
        }
    },
    actions:{
        getTodo({commit},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.get('todo/list',{
                params: payload
            })
                .then(response => response.json())
                .then( todoData => {
                    commit("getTodo",todoData);
                })
                .catch( error => {
                    console.log(error);
                })
        },
        setItemDone({commit,dispatch},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.post('todo/setitemdone',{
                ...payload
            })
                .then(response => response.json())
                .then( todoData => {
                    dispatch('getTodo');
                })
                .catch( error => {
                    console.log(error);
                })
        },
        setItemUnDone({commit,dispatch},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.post('todo/setitemundone',{
                ...payload
            })
                .then(response => response.json())
                .then( todoData => {
                    dispatch('getTodo');
                })
                .catch( error => {
                    console.log(error);
                })

        },
        addCustomItem({commit,dispatch},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.post('todo/addcustomitem',{
                ...payload
            })
                .then(response => response.json())
                .then( customItem => {
                    commit('customItemAdded', customItem)
                })
                .catch( error => {
                    commit('customItemResponse', error)
                })

        },
        updateWeekItem({commit,dispatch},payload) {
            Vue.http.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

            Vue.http.put('todo/updateweekitem/'+payload.ID,{
                ...payload
            })
                .then(response => response.json())
                .then( weekItem => {
                    dispatch('getTodo');
                })
                .catch( error => {
                    console.log(error);
                })

        }
    }
};

export default todo;